import styled from 'styled-components';
import { Checkbox } from 'ui/checkboxV2';

import { BaseCell } from './BaseCell';

const StyledCheckbox = styled(Checkbox)`
  margin: 0;
  & {
    vertical-align: middle;
  }
  &&&& label:before {
    border-color: ${(props) => (props.checked ? '#333' : '#bbbbbe')};
  }
  label {
    min-height: inherit;
    padding-left: 0;
  }
`;

// type CheckboxCellProps = {
//   checked?: boolean,
//   value: string,
//   dataTest?: string,
//   onClick: () => {},
// };

export const CheckboxCell = ({ checked, value, onClick, dataTest }) => (
  <BaseCell>
    <StyledCheckbox
      status={checked}
      setChecked={onClick}
      label={''}
      id={value}
      data-test={`${dataTest}-checkbox-cell`}
    />
  </BaseCell>
);

export const CleanCheckboxCell = ({ checked, value, onClick, dataTest }) => (
  <StyledCheckbox
    checked={checked}
    onClick={onClick}
    id={value}
    data-test={`${dataTest}-clean-checkbox-cell`}
  />
);
